import EnterpriseComponent from "../EnterpriseComponent";
import {V1AccountUserIDOCToArray} from "../../../util/Payload";
import AxiosRestAPI from "../../../util/AxiosRestAPI";
import {v4 as uuidv4} from "uuid";

class AccountUserEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AccountUser-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "AccountUser": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.PlatformMessage.AccountUser.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        AxiosRestAPI({
            method: "GET",
            url: "t6/v1/account_users",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AccountUserIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let accountUser = {
            "Name": this.getAttributeValue("Name"),
            "Email": this.getAttributeValue("Email"),
            "Password": this.getAttributeValue("Password"),
            "UserStatus": "ACTIVE"
        }

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.AccountUser-001";
        payload.PlatformMessage.AccountUser = accountUser;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t6/v1/account_users",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AccountUser-001",
                "idoc-response": "v1.AccountUser-001"
            },
        };
        this.notifyInsertStartListeners();
        AxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AccountUserIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

}

export default AccountUserEnterpriseComponent;